import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAtom } from 'jotai';
import { Header } from 'Components/Common';
import { useTranslation } from 'react-i18next';
import { BottomContainerAction, ButtonActions } from 'Components/UI';
import { formattingDigitCurrency } from 'utils';
import { Total } from '../../Total';
import { ListProductsSelected } from '../../Product';
import { Typography, Grid, makeStyles } from '@material-ui/core';
import {
  ticketAtom,
  goToPayAtom,
  shareNoteAtom,
  amountToPayAtom,
  listProductsToPayAtom,
  amountToPayPerProductAtom,
  stepPaymentTicketAtom,
  listProductsSelectedToPayAtom
} from 'Atoms/Ticket';
import { staticDataAtom } from 'Atoms/Common';
import { Link, useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: theme.containerGrid,
  sharePartContainer: {
    backgroundColor: 'rgba(90, 200, 245, 0.1)',
    height: '55px',
    margin: '.3rem 0 10rem 0',
  },
  sharePart: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  label: {
    fontWeight: 700,
    fontFamily: ['FuturaStdBook', 'sans-serif'].join(','),
    margin: '0 1rem',
  },
  disabled: {
    pointerEvents: 'none',
  },
}));

const ShareNoteProduct = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const [ticket] = useAtom(ticketAtom);
  const [staticData] = useAtom(staticDataAtom);
  const [amountToPay, setAmountToPay] = useAtom(amountToPayAtom);
  const [listProductsToPay] = useAtom(listProductsToPayAtom);
  const [, setGoToPay] = useAtom(goToPayAtom);

  const { id, order } = ticket || {};
  const { countryCode, labelCode, symbol } = staticData?.currency;

  const [myPartToPaid, setMyPartToPaid] = useState({ amount: 0, quantity: 0 });

  const initLabel = t('no_products_selected');

  const [labelButtonAction, setLabelButtonAction] = useState(initLabel);
  const [, setAmountToPayPerProduct] = useAtom(amountToPayPerProductAtom);
  const [, setStepPaymentTicket] = useAtom(stepPaymentTicketAtom);
  const [shareNote, setShareNote] = useAtom(shareNoteAtom);
  const [, setProductSelected] = useAtom(listProductsSelectedToPayAtom)

  useEffect(() => {
    setProductSelected([])
  }, [])

  useEffect(() => {
    if (myPartToPaid.quantity !== 0) {
      const newLabel = `${myPartToPaid.quantity}${t('x')} ${t('products')} (${totalMyPartToPaidFormatting})`;
      setLabelButtonAction(newLabel);
    } else {
      setLabelButtonAction(initLabel);
    }
    setAmountToPayPerProduct(amountToPay);

  }, [myPartToPaid, amountToPay]);

  const delayRedirect = (e) => {
    e.preventDefault()
    setStepPaymentTicket('checkout')

    const tipsDisabled = ticket.tips && ticket.tips.enable === false
    if(tipsDisabled) setGoToPay(true)
    
    const to = tipsDisabled ? `/ticket/:${id}/pay/form` : `/ticket/:${id}/tips`
    setTimeout(() => history.push(to), 700)
  }

  const totalMyPartToPaidFormatting = formattingDigitCurrency(
    amountToPay,
    countryCode,
    labelCode,
  );

  return (
    <>
      <Header
        title={t('my_ticket')}
        actions={{
          prev: {
            icon: 'return',
            label: t('share'),
            path: `/ticket/:${id}/share`,
          },
        }}
      ></Header>
      <Grid container className={classes.root}>
        <ListProductsSelected
          listProducts={listProductsToPay}
          myPartToPaid={myPartToPaid}
          setMyPartToPaid={setMyPartToPaid}
        />
        <Total
          totals={{ amount: amountToPay }}
          label={t('totalToPay')}
          currency={staticData?.currency}
          styles={{ bold: true }}
        />
        <Grid container className={classes.sharePartContainer}>
          <Grid item xs={12} className={classes.sharePart}>
            <Typography display="inline" variant="h6" className={classes.label}>
              {t('your_part')}
            </Typography>
            <Typography display="inline" variant="h6" className={classes.label}>
              {totalMyPartToPaidFormatting}
            </Typography>
          </Grid>
        </Grid>

        <BottomContainerAction>
          <Link
            to={{}}
            className={myPartToPaid?.amount === 0 ? classes.disabled : ''}
            onClick={(e) => delayRedirect(e)}
          >
            <ButtonActions
              label={labelButtonAction}
              color="primary"
              disabled={myPartToPaid?.amount === 0}
            />
          </Link>
        </BottomContainerAction>
      </Grid>
    </>
  );
};

ShareNoteProduct.propTypes = {};

export default ShareNoteProduct;
